import React, { useState } from 'react';
import { Modal } from '../../../../components/modal';
import { IBusinessDetailsprops } from '../../../../interface/business';
import UtilityBill from './utilityBill';

const Utilities = ({ business, refetch }: IBusinessDetailsprops) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <div>
      <div
        onClick={() => {
          setOpen(true);
        }}
        className="bg-activeLinkBlack rounded-normal p-5 flex items-center justify-between cursor-pointer">
        <p>Utilities</p>
        <div className="bg-bColor py-1 px-2 gap-2 rounded-md text-[8px] flex">
          <div className="mx-2">
            Verification: {business.verification.utilityBill.validated ?? '---'}
          </div>
        </div>
      </div>
      <Modal
        isVisible={open}
        close={setOpen}
        header
        center
        title="utilities"
        overflow
        padding={false}>
        <UtilityBill item={business} refetch={refetch} />
      </Modal>
    </div>
  );
};

export default Utilities;
